/* eslint-disable no-console */
/* eslint-disable func-names */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { makeStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CardContent from '@mui/material/CardContent';
import Menu from '@mui/material/Menu';
import ListItemIcon from '@mui/material/ListItemIcon';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import CardHeader from '@mui/material/CardHeader';
import Avatar from '@mui/material/Avatar';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useRecoilValue, useRecoilState, useSetRecoilState } from 'recoil';
import EditIcon from '@mui/icons-material/Edit';
import ProgressBar from './ProgressBar';
import ProjectPage from './ProjectPage';
import RadarChart from '../Shared/RadarChart';
import { openProjectNameAtom, projectsDataAtom, mobileAtom, userDataAtom, editAtom, logoToSetAtom } from '../Atoms';

/**Style of MUI components**/
const useStyles = makeStyles({
  cardMinSpace: {
    minWidth: '350px',
    minHeight: '400px',
    maxWidth: '400px',
    maxHeight: '450',
  },
  cardContainer: {
    padding: '.5vh',
    margin: '1vh',
    backgroundColor: '#fff',
    boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
  },
  goTo: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  btnItem: {
    position: 'inherit',
    right: 0,
  },
  chart: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

const CardProject = function ({ projectName, logoObj }) {
  const classes = useStyles();
  const intl = useIntl();
  const projectsData = useRecoilValue(projectsDataAtom);
  const [currentProjectData, setCurrentProjectData] = useState([]);
  const [openProjectName, setOpenProjectName] = useRecoilState(openProjectNameAtom);
  const setLogoToSet = useSetRecoilState(logoToSetAtom);
  const [edit, setEdit] = useState(null);
  const mobile = useRecoilValue(mobileAtom);
  const userData = useRecoilValue(userDataAtom);
  const setEditDialog = useSetRecoilState(editAtom);

  useEffect(() => {
    setCurrentProjectData(projectsData.find((x) => x.Name === projectName && x.isCurrent === 1));
  }, [projectsData]);

  const steps = [
    {
      label: 'RV1',
      description: `${intl.messages.RV1}`,
    },
    {
      label: 'RV2',
      description: `${intl.messages.RV2}`,
    },
    {
      label: 'RV3',
      description: `${intl.messages.RV3}`,
    },
    {
      label: 'RV4',
      description: `${intl.messages.RV4}`,
    },
    {
      label: 'RV5',
      description: `${intl.messages.RV5}`,
    },
    {
      label: 'RV6',
      description: `${intl.messages.RV6}`,
    },
    {
      label: 'RV7',
      description: `${intl.messages.RV7}`,
    },
  ];
  /**Returns the percentage for the progressBar**/
  const getPercentage = (value) => {
    let p = 0;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < steps.length; i++) {
      if (steps[i].label.substring(0, 3) === value) {
        p = (100 / 7) * (i + 1);
      }
    }
    return p;
  };
  const progressValue = getPercentage(currentProjectData?.finishedPhase);
  /**Returns the current step**/
  const getCurrentStep = (value) => {
    let index = 0;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < steps.length; i++) {
      if (steps[i].label.substring(0, 3) === value) {
        index = i + 1;
      }
    }
    if (index === 0) return 0;
    return index;
  };

  const handleOpenEditMenu = (e) => {
    setEdit(e.currentTarget);
  };
  const handleCloseEditMenu = () => {
    setEdit(null);
  };
  const openE = Boolean(edit);
  return (
    <Grid item sm={mobile ? 12 : 4} xs={mobile ? 12 : 4} key={currentProjectData?.id} className={classes.cardMinSpace}>
      <Card className={classes.cardContainer}>
        <CardHeader
          style={{ backgroundColor: '#b1cbbb', color: '#111' }}
          avatar={
            <Avatar
              //sx={{ bgcolor: '#00796b' }}
              src={
                logoObj
                  ? `data:${logoObj?.contentType};base64,${logoObj?.base64}`
                  : `data:${currentProjectData.LOGO?.contentType};base64,${currentProjectData.LOGO?.base64}`
              }
              variant="square"
            />
          }
          action={
            userData?.ruolo === 0 &&
            !mobile && (
              <div>
                <IconButton onClick={handleOpenEditMenu}>
                  <MoreVertIcon />
                </IconButton>
                <Menu id="editmenu" anchorEl={edit} open={openE} onClose={handleCloseEditMenu}>
                  <MenuItem
                    onClick={() => {
                      handleCloseEditMenu();
                      setEditDialog(projectName);
                    }}
                  >
                    <ListItemIcon>
                      <EditIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>{intl.messages.EDIT}</ListItemText>
                  </MenuItem>
                </Menu>
              </div>
            )
          }
          title={currentProjectData?.Name}
          subheader={currentProjectData?.Client}
        />
        <CardContent style={{ paddingBottom: 0 }}>
          <Container className={classes.chart} sx={{ mb: 10, maxWidth: '100px' }}>
            <RadarChart projectName={projectName} />
          </Container>
          <Container sx={{ mt: mobile ? 15 : 7, mb: 4 }}>
            <Typography noWrap mb={1} variant="subtitle2" sx={{ textOverflow: 'ellipsis' }}>{`RV${
              getCurrentStep(currentProjectData?.finishedPhase) + 1
            } - ${steps[getCurrentStep(currentProjectData?.finishedPhase) + 1].description}`}</Typography>
            <ProgressBar value={progressValue} />
          </Container>
          <Typography variant="subtitle2">{intl.messages.PROJECTMANAGER}</Typography>
          <Typography variant="subtitle1">{currentProjectData?.Pm}</Typography>
          <div className={classes.goTo} sx={{ mr: 0 }}>
            <Button
              onClick={() => {
                setOpenProjectName(projectName);
                setLogoToSet(logoObj);
              }}
              variant="outlined"
              className={classes.btnItem}
              startIcon={<VisibilityIcon />}
            >
              {intl.messages.GOTOPROJECT}
            </Button>
          </div>
          {openProjectName === projectName && <ProjectPage close={() => setOpenProjectName(null)} />}
        </CardContent>
      </Card>
    </Grid>
  );
};

export default CardProject;
